import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../../../helpers/request';
import { Color, ColorsResponse } from './types';

const baseUrl = `/colors`;

const COLORS_TTL_MS = 1000 * 60; // 1 minute

type StateWithColorsReducer = { colorsReducer: { fetchedAt?: number } };

export const getColorsAction = createAsyncThunk<ColorsResponse<Color[]> | undefined, undefined, { state: StateWithColorsReducer }>(
    'colors/getColors',
    async () => {
        const result = await http<ColorsResponse<Color[]>, undefined>({
            path: baseUrl,
            method: 'get',
        });
        return result.parsedBody;
    },
    {
        condition: (_, { getState }) => {
            const { fetchedAt } = getState().colorsReducer;
            if (fetchedAt && Date.now() - fetchedAt < COLORS_TTL_MS) {
                return false;
            }
            return true;
        },
    },
);

export default getColorsAction;
